<ng-container *transloco="let t">
  <!-- Header -->
  <form [formGroup]="usersForm" class="filter">
    <!-- Search -->
    <div class="form-group search-child">
      <i class="material-symbols-rounded prepend-icon">search</i>
      <input
        type="text"
        formControlName="search"
        class="form-control form-control-prepend form-control-rounded"
        [placeholder]="t('users/name')"
      />
    </div>
    <!-- Expired switch -->
    <div class="form-check form-switch">
      <input formControlName="expired" class="form-check-input" type="checkbox" role="switch" />
      <label class="form-check-label mb-0" for="archivedGroup">
        {{ t('users/expiredInvitations') }}
      </label>
    </div>
    <!-- Add users -->
    <a class="btn btn-primary btn-icon" [routerLink]="links.userInvite()">
      <i class="material-symbols-rounded">add_2</i>
      {{ t('users/inviteUsers') }}
    </a>
  </form>

  <!-- Content -->
  <div class="page-layout-sub">
    <div class="table-wrapper">
      <table class="table">
        <thead>
          <tr>
            <ng-container
              *ngTemplateOutlet="tableColumnHeader; context: { text: t('user/firstName'), field: specialFilters.NAME }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="tableColumnHeader; context: { text: t('user/email'), field: specialFilters.EMAIL }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="tableColumnHeader; context: { text: t('user/role'), field: specialFilters.ROLE }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="tableColumnHeader; context: { text: t('user/invited'), field: specialFilters.INVITED }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="tableColumnHeader; context: { text: t('user/lastLoggin'), field: specialFilters.LAST_LOGIN }"
            ></ng-container>
            <th scope="col">{{ t('user/action') }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="users$ | async as users; else loading">
            <ng-container *ngIf="users.length > 0; else noResults">
              <app-user-row
                *ngFor="let user of users"
                [data]="user"
                (resendInvitation)="onResendInvitation($event)"
                (deleteInvitation)="onDeleteInvitation($event)"
                (refreshData)="reloadUsers$.next()"
              >
              </app-user-row>
            </ng-container>

            <ng-template #noResults>
              <tr class="no-results" height="64px">
                <td colspan="6">
                  {{ t('groups/noGroupFound') }}
                </td>
              </tr>
            </ng-template>
          </ng-container>

          <ng-template #loading>
            <tr height="64px">
              <td colspan="6" class="text-center">
                {{ t('shared/loading') }}
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<ng-template #tableColumnHeader let-text="text" let-field="field">
  <th scope="col" class="with-filter">
    <isophi-app-sortable
      [fieldName]="field"
      [title]="text"
      (orderingChange)="onOrderingChange()"
      [(ordering)]="ordering"
    ></isophi-app-sortable>
  </th>
</ng-template>
